/**
 * /checkin/policies — placeholder policy hub. Full legal text lives in the
 * admin dashboard (Phase 5) and can be edited without a redeploy.
 */
import { Link } from "react-router-dom";
import { CheckInShell, CheckInLogo, GhostButton, CHECKIN_PALETTE } from "./_shell";

function Card({ title, children, testid }) {
  return (
    <div className="rounded-2xl border p-4 mt-3"
         style={{ borderColor: CHECKIN_PALETTE.silverSoft, background: "white" }}
         data-testid={testid}>
      <div className="text-[10px] uppercase tracking-[0.22em] font-semibold"
           style={{ color: CHECKIN_PALETTE.purple }}>{title}</div>
      <div className="mt-2 text-[13px] leading-relaxed" style={{ color: "#3A3348" }}>
        {children}
      </div>
    </div>
  );
}

export default function CheckInPolicies() {
  return (
    <CheckInShell testid="checkin-policies">
      <div className="pt-2 flex items-center justify-between">
        <CheckInLogo small />
        <Link to="/checkin" className="text-xs" style={{ color: CHECKIN_PALETTE.purple }}
              data-testid="policies-back">← Back</Link>
      </div>

      <div className="mt-8">
        <h1 className="font-serif text-3xl leading-tight"
            style={{ color: CHECKIN_PALETTE.ink, fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
          Policies &amp; disclosures
        </h1>
        <p className="mt-2 text-[13.5px]" style={{ color: "#5C5468" }}>
          These are placeholders while our team finalizes the full policy
          text. Each policy will be reviewed and versioned before public launch.
        </p>
      </div>

      <Card title="Companion Disclosure" testid="policy-disclosure">
        Check In with Dr. C uses technology trained on Dr. C&rsquo;s approved
        voice, frameworks, and resources. Responses may not be written live
        by Dr. C, and the service is not continuously monitored. It is
        designed for education, reflection, and coaching support — not
        emergencies, diagnosis, therapy, or medical treatment.
      </Card>

      <Card title="Privacy Notice" testid="policy-privacy">
        We collect only the information we need to provide your check-ins.
        Your conversations belong to you. You may export or delete your
        account data at any time from your profile. We never sell your
        conversations, and we do not use them to train external models.
      </Card>

      <Card title="Terms of Use" testid="policy-terms">
        You must be 18 or older to use Check In with Dr. C. You agree to
        use the service for personal, non-emergency support. Talk Credit
        purchases and subscriptions follow the credit-and-refund policy
        published in your account.
      </Card>

      <Card title="Refund &amp; Credit Policy" testid="policy-refund">
        Unused Talk Credits carry between billing cycles unless otherwise
        stated. Refunds are considered on a case-by-case basis. Failed
        responses never consume a Talk Credit.
      </Card>

      <div className="mt-8">
        <Link to="/checkin"><GhostButton testid="policies-home">Return to welcome</GhostButton></Link>
      </div>
    </CheckInShell>
  );
}
